import { api } from "@/lib/api";

export const BOOK_MODELS = [
  { id: "gpt-4o-mini", label: "GPT-4o mini (fastest, default)" },
  { id: "gpt-4o", label: "GPT-4o (OpenAI)" },
  { id: "claude-sonnet-4-5", label: "Claude Sonnet 4.5 (Anthropic)" },
  { id: "claude-haiku-4-5", label: "Claude Haiku 4.5 (Anthropic)" },
  { id: "gemini-2.5-pro", label: "Gemini 2.5 Pro (Google)" },
];

export const generateBooks = (courseId, body) =>
  api.post(`/courses/${courseId}/books/generate`, body).then((r) => r.data);

export const booksStatus = (courseId) =>
  api.get(`/courses/${courseId}/books/status`).then((r) => r.data);

export const listBooks = (courseId) =>
  api.get(`/courses/${courseId}/books`).then((r) => r.data);

export const getChapterBook = (courseId, chapterId) =>
  api.get(`/courses/${courseId}/chapters/${chapterId}/book`).then((r) => r.data);

export const patchChapterBook = (courseId, chapterId, patch) =>
  api
    .patch(`/courses/${courseId}/chapters/${chapterId}/book`, patch)
    .then((r) => r.data);

export const putBookSettings = (courseId, body) =>
  api.put(`/courses/${courseId}/book-settings`, body).then((r) => r.data);

export const getStudentChapterBook = (courseId, chapterId) =>
  api
    .get(`/student/courses/${courseId}/chapters/${chapterId}/book`)
    .then((r) => r.data);

export const openChapterBookPdf = async (courseId, chapterId) => {
  const r = await api.get(
    `/courses/${courseId}/chapters/${chapterId}/book.pdf`,
    { responseType: "blob" }
  );
  const blob = new Blob([r.data], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  window.open(url, "_blank", "noopener,noreferrer");
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
};
